import {AppBar, AppBarProps, Grid, Toolbar, Typography, ButtonBase, Container} from "@mui/material";
import React from "react";
import {LogoVertical} from "~/ui/icons";


export type BrandAppBarProps = AppBarProps & {
    onBrandClick?: () => void
    actions?: any
};


export const BrandAppBar = (props: BrandAppBarProps) => {
    const {onBrandClick, actions, ...appBarProps} = props;

    return (
        <>
            <AppBar position="fixed" color="inherit" {...appBarProps}>
                <Container disableGutters>
                    <Toolbar>
                        <ButtonBase onClick={onBrandClick}>
                            <Grid container alignItems="center" component="span">
                                <LogoVertical style={{ height: 40 }}/>
                                <Typography variant="headerTitle"  color="primary" style={{marginLeft: 8}}>
                                    Порт в кармане
                                </Typography>
                            </Grid>
                        </ButtonBase>
                        <div style={{flexGrow: 1}}/>
                        {actions}
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    )
}